export class Tokens {
  accessToken: string;
  refreshToken: string;
  msisdn: string;

  constructor(accessToken: string, refreshToken: string, msisdn?: string) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.msisdn = msisdn;
  }
}
